// services/PostcodeServiceFactory.ts

import PostcodeService from './PostcodeService';
import PostcodeServiceUS from './PostcodeServiceUS';
import { IPostcodeService } from '../types/postcode';
import { getRemoteEnv } from '../config/remoteEnv';

export class PostcodeServiceFactory {
  private static postcodeServiceInstance: IPostcodeService | null = null;

  public static getPostcodeService(): IPostcodeService {
    if (!this.postcodeServiceInstance) {
      const countryCode = getRemoteEnv().countryCode || 'GB';
      
      switch (countryCode) {
        case 'US':
          this.postcodeServiceInstance = PostcodeServiceUS.getInstance();
          break;
        case 'GB':
        default:
          this.postcodeServiceInstance = PostcodeService.getInstance();
          break;
      }
    }
    
    return this.postcodeServiceInstance;
  }

  // Reset instance for testing purposes
  public static resetInstance(): void {
    this.postcodeServiceInstance = null;
  }
}